import script from "./Series.vue?vue&type=script&setup=true&lang=js"
export * from "./Series.vue?vue&type=script&setup=true&lang=js"

import "./Series.vue?vue&type=style&index=0&id=32e60ae0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32e60ae0"]])

export default __exports__